import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_ColorGroup } from '@app/dp-shared';
export const dispatch_onColorGroupChanged = new ThunderDispatcherV3('__onColorGroupUpdated');
export class ModuleFE_ColorGroup_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_ColorGroup, dispatch_onColorGroupChanged);
    }
}
export const ModuleFE_ColorGroup = new ModuleFE_ColorGroup_Class();
//# sourceMappingURL=ModuleFE_ColorGroup.js.map